import React, { Component } from 'react'
import { ThemeProvider } from 'styled-components'
import merge from 'deepmerge'

import getBaseTheme from '../../shared/theming-core'

export default class AppTheme extends Component {
  render() {
    const { mode, children, themeOverrides = {}, ...rest } = this.props
    const baseTheme = getBaseTheme({ mode })

    const builtTheme = {
      mode,
      ...merge(baseTheme, themeOverrides),
      ...rest
    }

    return (
      <ThemeProvider theme={builtTheme}>
        {children}
      </ThemeProvider>
    )
  }
}
